export const light = {
    // body: '#353434', //Black shade
    principal: '#353434',
    textRgba: '231,62,17',
    bodyRgba: '53,52,52',
    white: '#ffff',


    purple: '#d9c0a1', // grey shade

    fontxs: '0.75em', //1em = 16px
    fontsm: '0.875em',
    fontmd: '1em',
    fontlg: '1.25em',
    fontxl: '2em',
    fontxxl: '3em',
    fontxxxl: '4rem',
    fontxxxxl: '5em',
    fontBig: '10em',

    navHeight: '5rem'
}